import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Seo — declarative page-level metadata.
 * Sets <title>, <meta name="description">, OG tags, and canonical URL.
 *
 * Props:
 *   title: string — appears as full <title> (already fully qualified, e.g. "ZenMe Capital · About")
 *   description: string — 140–160 chars
 *   path: string — path portion of canonical URL (e.g. "/zenscore")
 *   siteUrl: string — override base URL if needed (defaults to "https://zenmecapital.com")
 *   type: string — og:type (default "website")
 */
export const Seo = ({
  title,
  description,
  path = "/",
  siteUrl = "https://zenmecapital.com",
  type = "website",
}) => {
  const url = `${siteUrl}${path.startsWith("/") ? path : `/${path}`}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default Seo;
